export { default } from './ProductTabNavigator';
export * from './ProductTabNavigator';
